/**
 * Collection Filter & Sort helpers.
 * - Done (N) is the number of products that match every active filter.
 * - Colors come from product titles/handles in this collection.
 * - Size is matched on variant option values (XS–3XL), not option.name === "Size"
 *   because this catalog names that option Top/Dress/Trouser/etc.
 */
(function () {
  if (window.__croCollectionFilters) return;
  window.__croCollectionFilters = true;

  var COLOR_HEX = {
    black: '#0d0d0d',
    white: '#f4f4f4',
    'off-white': '#f3efe6',
    ivory: '#fffff0',
    beige: '#d8c3a5',
    'desert-beige': '#cbb394',
    'sand-beige': '#d5c4a1',
    sand: '#c2b280',
    khaki: '#c3b091',
    brown: '#684006',
    'cocoa-brown': '#5c3a21',
    'golden-brown': '#996515',
    red: '#c23b3b',
    rust: '#b7410e',
    burgundy: '#6e1e32',
    wine: '#722f37',
    'wine-pinstripe': '#722f37',
    pink: '#df3873',
    'cool-pink': '#e38aae',
    'pearl-pink': '#f5d0d6',
    'dusty-blush-pink': '#d4a5a5',
    mauve: '#c49bb3',
    'dusky-mauve': '#b0849a',
    fuchsia: '#c13584',
    lilac: '#c8a2c8',
    'silverish-lilac': '#c5b4d0',
    plum: '#6b3a5d',
    yellow: '#eaea3f',
    'butter-yellow': '#f5d76e',
    peach: '#f5c3a8',
    'peach-fuzz': '#ffcba4',
    green: '#147c32',
    'lime-green': '#9bcf53',
    'leafy-green': '#4f8a3a',
    'olive-green': '#6b7c3a',
    'peacock-green': '#1a6b5c',
    'bottle-green': '#0b3d2e',
    'bottle-green-cotton-linen': '#0b3d2e',
    blue: '#2f5d9f',
    'navy-blue': '#1b2a4a',
    'midnight-blue': '#191970',
    'midnight-navy': '#191970',
    'sky-blue': '#87ceeb',
    'powder-blue': '#b0c4de',
    'cobalt-blue': '#0047ab',
    'denim-blue': '#3b5f8a',
    grey: '#8a8a8a',
    gray: '#8a8a8a',
    'smokey-grey': '#8a8a8a',
    'steel-grey': '#71797e',
    'bluish-grey': '#6d7a86',
    mushroom: '#b8a38a',
    'pearl-white': '#f8f6f0',
  };

  function parseColor(title) {
    if (!title) return '';
    var label = '';
    if (title.indexOf('–') !== -1) label = title.split('–').pop();
    else if (title.indexOf(' - ') !== -1) label = title.split(' - ').pop();
    else if (title.indexOf(',') !== -1) {
      var tail = title.split(',').pop().trim();
      if (tail.length <= 40) label = tail;
    }
    return String(label || '')
      .replace(/\(.*\)/g, '')
      .trim();
  }

  function colorKey(label) {
    return String(label || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function variantSizes(variant) {
    return [variant.option1, variant.option2, variant.option3, variant.title].filter(Boolean);
  }

  function productMatches(product, filters) {
    var variants = product.variants || [];
    var color = colorKey(parseColor(product.title));
    if (filters.colors.length && filters.colors.indexOf(color) === -1) return false;

    return variants.some(function (variant) {
      var price = Number(variant.price);
      if (filters.minPrice != null && price < filters.minPrice) return false;
      if (filters.maxPrice != null && price > filters.maxPrice) return false;
      var sizes = variantSizes(variant);
      if (filters.sizes.length && !filters.sizes.some(function (size) { return sizes.indexOf(size) !== -1; })) {
        return false;
      }
      if (filters.availability === 'in' && !variant.available) return false;
      if (filters.availability === 'out' && variant.available) return false;
      return true;
    });
  }

  function readFilters() {
    var params = new URLSearchParams(window.location.search);
    var form = document.querySelector('#filters-drawer form') || document.querySelector('form.facets__form');
    var data = form ? new FormData(form) : null;

    function all(name) {
      if (data) return data.getAll(name).filter(Boolean);
      return params.getAll(name).filter(Boolean);
    }

    var sizes = all('cro_size');
    if (!sizes.length) sizes = all('filter.v.option.size');

    var colors = all('cro_color');

    var minRaw = (all('filter.v.price.gte')[0] || '').replace(/[^\d.]/g, '');
    var maxRaw = (all('filter.v.price.lte')[0] || '').replace(/[^\d.]/g, '');
    var minPrice = minRaw === '' ? null : Number(minRaw);
    var maxPrice = maxRaw === '' ? null : Number(maxRaw);

    var avail = all('filter.v.availability');
    var availability = null;
    if (avail.indexOf('1') !== -1 && avail.indexOf('0') === -1) availability = 'in';
    else if (avail.indexOf('0') !== -1 && avail.indexOf('1') === -1) availability = 'out';

    var extra = Boolean(
      sizes.length ||
        colors.length ||
        minPrice != null ||
        maxPrice != null
    );

    return { sizes: sizes, colors: colors, minPrice: minPrice, maxPrice: maxPrice, availability: availability, extra: extra };
  }

  function setDoneCount(count) {
    window.__croFilterMatchCount = count;
    window.__croPriceMatchCount = count;
    var patternEl = document.querySelector('[data-bc-filters-done]');
    var pattern = (patternEl && patternEl.getAttribute('data-done-pattern')) || 'Done (__COUNT__)';
    document.querySelectorAll('[data-bc-filters-done]').forEach(function (el) {
      el.textContent = pattern.replace(/__COUNT__/g, String(count));
    });
    document.querySelectorAll('[data-bc-collection-count]').forEach(function (el) {
      el.textContent = count === 1 ? '1 item' : count + ' items';
    });
    var bubble = document.getElementById('filters-drawer-bubble');
    if (bubble) {
      var filters = readFilters();
      var n = (filters.sizes.length ? 1 : 0) + (filters.colors.length ? 1 : 0);
      if (filters.minPrice != null || filters.maxPrice != null) n += 1;
      if (filters.availability) n += 1;
      bubble.hidden = false;
      bubble.textContent = String(n);
    }
  }

  var productsCache = {};
  function getProducts(handle) {
    if (!handle) return Promise.resolve([]);
    if (productsCache[handle]) return productsCache[handle];
    productsCache[handle] = (async function () {
      var all = [];
      for (var page = 1; page <= 10; page++) {
        var response = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + page);
        if (!response.ok) break;
        var data = await response.json();
        var batch = data.products || [];
        all.push.apply(all, batch);
        if (batch.length < 250) break;
      }
      return all;
    })();
    return productsCache[handle];
  }

  function collectionHandle() {
    var form = document.querySelector('facets-form-component[data-collection-handle]');
    if (form && form.dataset.collectionHandle) return form.dataset.collectionHandle;
    var parts = window.location.pathname.split('/collections/');
    return parts[1] ? parts[1].split('/')[0] : '';
  }

  function applyGrid(filters) {
    document.querySelectorAll('.product-grid__item').forEach(function (el) {
      var ok = true;
      if (filters.colors.length) {
        ok = filters.colors.indexOf(el.getAttribute('data-cro-color') || '') !== -1;
      }
      if (ok && filters.sizes.length) {
        var sizeAttr = ',' + (el.getAttribute('data-cro-sizes') || '') + ',';
        var availAttr = ',' + (el.getAttribute('data-cro-available-sizes') || '') + ',';
        var pool = filters.availability === 'in' ? availAttr : sizeAttr;
        ok = filters.sizes.some(function (size) {
          return pool.indexOf(',' + size + ',') !== -1;
        });
      } else if (ok && filters.availability === 'in') {
        ok = Boolean((el.getAttribute('data-cro-available-sizes') || '').replace(/,/g, '').trim());
      } else if (ok && filters.availability === 'out') {
        ok = !(el.getAttribute('data-cro-available-sizes') || '').replace(/,/g, '').trim();
      }
      if (ok && (filters.minPrice != null || filters.maxPrice != null)) {
        var pmin = Number(el.getAttribute('data-price-min') || 0) / 100;
        var pmax = Number(el.getAttribute('data-price-max') || 0) / 100;
        var lo = filters.minPrice == null ? 0 : filters.minPrice;
        var hi = filters.maxPrice == null ? Infinity : filters.maxPrice;
        ok = pmax >= lo && pmin <= hi;
      }
      el.hidden = !ok;
    });
  }

  function swatchStyle(label, image) {
    var key = colorKey(label);
    if (COLOR_HEX[key]) return 'background:' + COLOR_HEX[key];
    var first = key.split('-')[0];
    if (COLOR_HEX[first]) return 'background:' + COLOR_HEX[first];
    if (image) return 'background-image:url(' + image + ');background-size:cover;background-position:center';
    return 'background:#d1d5dc';
  }

  function renderColors(products) {
    var roots = document.querySelectorAll('[data-cro-color-filter]');
    if (!roots.length) return;

    var map = {};
    products.forEach(function (product) {
      var label = parseColor(product.title);
      var key = colorKey(label);
      if (!key) return;
      if (!map[key]) {
        var image = product.images && product.images[0] && product.images[0].src;
        map[key] = { key: key, label: label, image: image };
      }
    });
    var colors = Object.keys(map)
      .map(function (key) { return map[key]; })
      .sort(function (a, b) { return a.label.localeCompare(b.label); });

    var selected = readFilters().colors;

    roots.forEach(function (root, rootIndex) {
      var list = root.querySelector('[data-cro-color-list]');
      if (!list) return;
      root.hidden = colors.length === 0;
      list.innerHTML = colors
        .map(function (color, index) {
          var id = 'cro-color-' + rootIndex + '-' + index;
          var checked = selected.indexOf(color.key) !== -1 ? ' checked' : '';
          return (
            '<li class="facets__inputs-list-item">' +
            '<label class="cro-color-filter__row" for="' + id + '">' +
            '<input id="' + id + '" class="visually-hidden" type="checkbox" name="cro_color" value="' +
            color.key +
            '"' +
            checked +
            '>' +
            '<span class="cro-color-filter__swatch" style="' + swatchStyle(color.label, color.image) + '"></span>' +
            '<span class="facets__swatch-label">' + color.label + '</span>' +
            '</label>' +
            '</li>'
          );
        })
        .join('');
    });
  }

  function sync() {
    var handle = collectionHandle();
    var filters = readFilters();
    applyGrid(filters);
    getProducts(handle).then(function (products) {
      renderColors(products);
      var count = products.filter(function (product) {
        return productMatches(product, filters);
      }).length;
      window.__croPriceFilterActive = filters.extra;
      setDoneCount(count);
      applyGrid(readFilters());
    });
  }

  window.__croSyncFilterCount = sync;

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;
    if (target.name === 'cro_color' || target.name === 'cro_size') {
      var formComp = target.closest('facets-form-component');
      if (formComp && typeof formComp.updateFilters === 'function') {
        formComp.updateFilters();
      }
      sync();
    }
  });

  document.addEventListener('shopify:collection:update', function () {
    requestAnimationFrame(sync);
  });
  document.addEventListener('collection:update', function () {
    requestAnimationFrame(sync);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  var applyTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(function () {
      applyGrid(readFilters());
    }, 50);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
